import React, { useState } from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";

interface TooltipBubbleProps {
  children: React.ReactNode;
  content: React.ReactNode;
  position?: "top" | "bottom";
  className?: string;
  trigger?: "hover" | "focus" | "static";
}

const TooltipBubble: React.FC<TooltipBubbleProps> = ({
  children,
  content,
  position = "top",
  className,
  trigger = "hover",
}) => {
  const [visible, setVisible] = useState(false);

  const show = () => trigger !== "static" && setVisible(true);
  const hide = () => trigger !== "static" && setVisible(false);

  const tooltip = (
    <div
      className={classNames(
        styles.tooltipContainer,
        styles[position],
        { [styles.visible]: trigger === "static" || visible },
        className
      )}>
      <div className={styles.arrow} />
      <div className={styles.tooltipContent}>{content}</div>
    </div>
  );

  if (trigger === "static") {
    return tooltip;
  }

  return (
    <div
      className={styles.wrapper}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}>
      {children}
      {tooltip}
    </div>
  );
};

export default TooltipBubble;
